"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var firebase_1 = require("./firebase");
var Datasource = /** @class */ (function (_super) {
    __extends(Datasource, _super);
    function Datasource(orgId) {
        var _this = _super.call(this, "") || this;
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/datasources/" + uid);
        };
        _this.getConfig = function (datasourceId) {
            return _this.getByPath("/datasources_config/" + _this.orgId + "/" + datasourceId);
        };
        _this.getAuthRoles = function (uid, datasourceId) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/datasources/" + uid + "/" + datasourceId);
        };
        _this.getMetadata = function (datasourceId) {
            return _this.getByPath("/datasources_metadata/" + _this.orgId + "/" + datasourceId);
        };
        _this.requestListMembers = function (orgId, uid, datasourceId) {
            var request = {
                audit: {
                    createdBy: uid
                },
                datasourceId: datasourceId
            };
            return _this.create("/apis/" + orgId + "/" + uid + "/list_datasource_members", request);
        };
        _this.addUserToResource = function (orgId, uid, datasourceId, userId) {
            var request = {
                audit: {
                    createdBy: uid
                },
                datasourceId: datasourceId,
                userId: userId
            };
            return _this.create("/apis/" + orgId + "/" + uid + "/add_user_to_datasource", request);
        };
        _this.orgId = orgId;
        return _this;
    }
    Datasource.prototype.deleteUserToResource = function (orgId, authUserId, datasourceId, userId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            datasourceId: datasourceId,
            userId: userId
        };
        return this.create("/apis/" + orgId + "/" + authUserId + "/deactivate_datasource_user", request);
    };
    ;
    Datasource.prototype.changePermissionToResource = function (orgId, authUserId, datasourceId, userId, newAccountType) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            datasourceId: datasourceId,
            userId: userId,
            newAccountType: newAccountType
        };
        return this.create("/apis/" + orgId + "/" + authUserId + "/change_datasource_user_account_type", request);
    };
    ;
    Datasource.prototype.deleteResource = function (authUserId, resourceId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            datasourceId: resourceId
        };
        return this.create("/apis/" + this.orgId + "/" + authUserId + "/delete_datasource", request);
    };
    ;
    Datasource.prototype.updateName = function (resourceId, config) {
        config.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
        return this.update("/datasources_config/" + this.orgId + "/" + resourceId, config);
    };
    return Datasource;
}(Base_1.default));
///apis/{orgId}/{callerId}/add_user_to_datasource/{requestId}
exports.default = Datasource;
//# sourceMappingURL=Datasources.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Datasources.js
// module id = 406
// module chunks = 8